import * as React from "react";
import type { SVGProps } from "react";
const SvgInvoiceListItem = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={20}
    fill="none"
    viewBox="0 0 18 20"
    {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 13.5h1M12 10h1M12 6.5h1M5 13.5h4M5 10h4M5 6.5h4"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17 17.425V2.575a1 1 0 0 0-.498-.865l-.99-.575a1 1 0 0 0-.998-.003L12.994 2l-1.488-.864a1 1 0 0 0-1-.002L9 2l-1.506-.866a1 1 0 0 0-1 .002L5.006 2l-1.52-.868a1 1 0 0 0-.998.003l-.99.575A1 1 0 0 0 1 2.575v14.85a1 1 0 0 0 .498.865l.99.575a1 1 0 0 0 .998.003L5.006 18l1.488.864a1 1 0 0 0 1 .002L9 18l1.506.866a1 1 0 0 0 1-.002L12.994 18l1.52.868a1 1 0 0 0 .998-.003l.99-.575a1 1 0 0 0 .498-.865"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInvoiceListItem;
